import { Maybe } from '../../../__generated__/globalTypes'

import {
  CalendarDateFragment,
  isCalendarDateFragment,
} from './CalendarDateFragment'

import noteFragmentRawString from '../NoteFragment.graphql'

export const noteFragmentString = noteFragmentRawString

export type NoteFragment = {
  __typename: 'Note'
  id: string
  text: string
  date: Maybe<CalendarDateFragment>
}

export const isNoteFragment = (fragment: any): fragment is NoteFragment =>
  fragment &&
  fragment.__typename === 'Note' &&
  typeof fragment.id === 'string' &&
  typeof fragment.text === 'string' &&
  (fragment.date === null || (isCalendarDateFragment(fragment.date) as boolean))
